export const medicalGroupName = "Curai Health Medical Group";
export const medicalGroupAbbr = "CHMG";
export const brandName = "Curai Health";
export const shortBrandName = "Curai";
